// import React, { Component } from 'react'
// import NewsItem from './NewsItem'
// import Spinner from './Spinner';
// import PropTypes from 'prop-types'
// import InfiniteScroll from "react-infinite-scroll-component";


// export default class news extends Component {
//   static defaultProps={
//     country:'in',
//     pageSize:8,
//     category:'general'
//   } 
//   static propTypes ={
//     country: PropTypes.string,
//     pageSize: PropTypes.number,
//     category:PropTypes.string
//   }
//   articles =  [     //this article array only for understanding
//     {
//       "source": {
//         "id": "google-news",
//         "name": "Google News"
//       },
//       "author": "Yahoo Sports",
//       "title": "Paris Olympics gymnastics live updates: Suni Lee earns bronze on bars as apparatus finals continue - Yahoo Sports",
//       "description": "The only new sport for the 2024 Olympics is breaking. It is a style of dance that originated in the Bronx in New York during the 1970s but has evolved to become a competitive sport In Paris, breaking will not be seen until the latter part of the Games, with the women's event taking place on 9 August and the men's on 10 August. A total of 32 entrants, 16 men and 16 women will compete for the medals.",
//       "url": "https://news.google.com/rss/articles/CBMi5AFBVV95cUxNMnRuVmFiTDhqbDJvbFVfeGYtNnpCZndOd0QxOG1aclZJNnBIZDUtOFVYSkJMWGdzRklPWHNldUdETUp0dUZyYll4THFJMHpQTDFfVGUzZVZlckJvYVFuS05fcVBZY0FGT2dpd05HOXBjdUd5Yjh0dGZnVTZHNmVwc0RJWDlBTm53Ym5fMFBNQTVEc2tVTDZ3a1dMdHpkX256bFlNeFZFeW5pZGJaT3gydzlyLVBVR2s1TE4xOTRQLW5LWTZWU2hXN1BOQy1KOU9XM1NlWGFRd2dxMzJ5ZGNUaFc5WFU?oc=5",
//       "urlToImage":"https://th.bing.com/th/id/OIP._osb0tUPwncqMqKUqcjdtAHaE8?w=243&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7",
//       "publishedAt": "2024-08-04T14:39:11Z",
//       "content": null
//     },
//     {
//       "source": {
//         "id": "google-news",
//         "name": "Google News"
//       },
//       "author": "The New York Times",
//       "title": "Florida Prepares for Landfall as Tropical Storm Debby Strengthens - The New York Times",
//       "description": "Kyle Martin and Kathy Hunt braved torrential downpour this morning in flooded Folly Beach, South Carolina, to clear drains in their neighborhood — which they described as their lifelines We’re trying to save our street from completely flooding right now,” Martin told NBC News. “The goal is going to be to keep these drains open as long as we can, because obviously, debris and everything comes flooding in … as soon as those drains stop, the water’s in our house.",
//       "url": "https://news.google.com/rss/articles/CBMiggFBVV95cUxPY1JaUTR6eS1BRXpmbV83MlptY2ZiTWdGeEFlZWY5LWM0a25vV3JkXzFXVnBhZDNZa042ZUc1T3F5T043WWtKVXk0dkc3UzR0aUdISUZFd0lnYnpUOHRqTnlxTWZ4WVFnZjFUb3ZLWlFiNHl4cHB2ektmYnJaYlI2NWpR?oc=5",
//       "urlToImage": "https://th.bing.com/th/id/OIP.L7BYPds2jcrYVFQFWqTcvAHaEK?w=319&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7",
//       "publishedAt": "2024-08-04T14:35:29Z",
//       "content": null
//     },
//     {
//       "source": {
//         "id": "google-news",
//         "name": "Google News"
//       },
//       "author": "Bloomberg",
//       "title": "The Stock Market Is Rotating. The Question is Where It Goes Next - Bloomberg",
//       "description": "GDP stands for Gross Domestic Product. It represents the market value of all the final goods and services produced within the geographical boundaries of a country within a specific time frame, typically a year or a quarter. GDP is a critical indicator of the economic health of a country. GDP at constant prices, also known as real GDP, is a measure of GDP that adjusts for changes in the overall price level ",
//       "url": "https://news.google.com/rss/articles/CBMitAFBVV95cUxPMmN2X1pvM1A4MlBFNWdjWU9jNXFweXBBRmMybkxfTGZwQ0NQTEhqUGd5dTlpQVF6bGdfRlhUVmtQZERxTTRzVDFGTl8xRENRZS1MRzhoUXFWWDFHdVd6dl85UHN5QUZQODRnNU0xR05wQnZrNExxZXFKYUR3VzFzNkt5LXVPZDM2cG1IcDVnbGFVZDJCZHBVWEV1VEkyZEkzQVNYNmU2c0ZBaG9MSDE4ZFNzWmc?oc=5",
//       "urlToImage": "https://th.bing.com/th/id/OIP.gtda7doxovR5dxwFnjFbkAHaE8?w=260&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7",
//       "publishedAt": "2024-08-04T13:00:07Z",
//       "content": null
//     },
//     {
//       "source": {
//         "id": "the-washington-post",
//         "name": "The Washington Post"
//       },
//       "author": "Erin Blakemore",
//       "title": "Chronic pain patients’ mental health needs often go unrecognized - The Washington Post",
//       "description": "An analysis finds that those with chronic pain are underserved “at every point” in the U.S. mental health-care system.",
//       "url": "https://www.washingtonpost.com/health/2024/08/04/chronic-pain-mental-health-depression/",
//       "urlToImage": "https://www.washingtonpost.com/wp-apps/imrs.php?src=https://arc-anglerfish-washpost-prod-washpost.s3.amazonaws.com/public/TUPT7FJPIP5C6N6ZMBRUTE42TM.JPG&w=1440",
//       "publishedAt": "2024-08-04T12:38:50Z",
//       "content": "People living with chronic pain are more likely than their peers without pain to need mental health treatment, yet less likely to get it, a new analysis suggests.\r\nThe study, published in the journal… [+1964 chars]"
//     },
//     {
//       "source": {
//         "id": null,
//         "name": "Financial Times"
//       },
//       "author": "Stefania Palma, Andrew England, Raya Jalabi",
//       "title": "Western governments step up calls for citizens to leave Lebanon - Financial Times",
//       "description": "Fears grow of all-out war in region after assassinations linked to Israel",
//       "url": "https://www.ft.com/content/f3532b67-bed9-4b8f-aa7c-95621899e974",
//       "urlToImage": "https://www.ft.com/__origami/service/image/v2/images/raw/https%3A%2F%2Fwww.ft.com%2F__origami%2Fservice%2Fimage%2Fv2%2Fimages%2Fraw%2Fhttps%253A%252F%252Fd1e00ek4ebabms.cloudfront.net%252Fproduction%252Fe95fad7c-9d01-4877-bd4f-60a11dadabb5.jpg%3Fsource%3Dnext-article%26fit%3Dscale-down%26quality%3Dhighest%26width%3D700%26dpr%3D1?source=next-opengraph&fit=scale-down&width=900",
//       "publishedAt": "2024-08-04T12:33:34Z",
//       "content": "Western governments have stepped up calls for their citizens to leave Lebanon while commercial flights are still available, as an anxious region braced for the possibility of a full-blown regional wa… [+4816 chars]"
//     },
//     {
//       "source": {
//         "id": "google-news",
//         "name": "Google News"
//       },
//       "author": "NBC News",
//       "title": "Far-right riots erupt in U.K. in the wake of child murders - NBC News",
//       "description": "GDP stands for Gross Domestic Product. It represents the market value of all the final goods and services produced within the geographical boundaries of a country within a specific time frame, typically a year or a quarter. GDP is a critical indicator of the economic health of a country. GDP at constant prices, also known as real GDP, is a measure of GDP that adjusts for changes in the overall price level ",
//       "url": "https://news.google.com/rss/articles/CBMikwFBVV95cUxNMWxRMXBHX0VOUEVuRjlUQUpQMTN2WW1JVno4VmNjdnJkUnRYdkc0VGF0NTJaUC1HRjR2aTJvNENtY2xoejMzQ09DcmloeFFIaEV6amVEekhXUHY0Zy11cmFXV1praWxfNmlXLURLUXFXZjZ3Nll0MDFrOHRWMFZXdmQwUTJoQ25kaGd2RmdQMlA2NmfSAVZBVV95cUxQUGlZZjNJd0JkcFl5a014dFQ2YkgwZXBRLXA5LWNsT0xzaFk2WmRqcVR4OWtlZ3BUbzFGeE9hLW9YTTZoYzFIOGRWUktpSUJZNjRlTzBWQQ?oc=5",
//       "urlToImage": "https://th.bing.com/th/id/OIP.dRmmiw7rcFQHZl2mUIzXhQHaE8?w=232&h=181&c=7&r=0&o=5&dpr=1.3&pid=1.7",
//       "publishedAt": "2024-08-04T12:29:51Z",
//       "content": null
//     },
//     {
//       "source": {
//         "id": "google-news",
//         "name": "Google News"
//       },
//       "author": "The Associated Press",
//       "title": "Drugstores tinker with new looks as their usual way of doing business faces challenges - The Associated Press",
//       "description": "GDP stands for Gross Domestic Product. It represents the market value of all the final goods and services produced within the geographical boundaries of a country within a specific time frame, typically a year or a quarter. GDP is a critical indicator of the economic health of a country. GDP at constant prices, also known as real GDP, is a measure of GDP that adjusts for changes in the overall price level ",
//       "url": "https://news.google.com/rss/articles/CBMingFBVV95cUxOM25VWUI3SU1VejlWTWtNUGQ4YWFDYV9VMllUeXpaQVZaYXVSOGdrQ2VMR3ozQ0R2QnFtcG82SnZiZnRFa3o2TzhPaUJJcGFLV0p3QUs0S0hYRVU2SHNpVm01T3piN2U4cVp6eXNzVXU5V2pWa0lFVXY2MmR3aDUzMF80RllVT2pQdC1YSm5RVHpMTzVoQzVPSWFhcGw1Zw?oc=5",
//       "urlToImage": "https://th.bing.com/th/id/OIP.wRONoPA3m3Cm9aN6TlpnngHaFi?w=264&h=197&c=7&r=0&o=5&dpr=1.3&pid=1.7",
//       "publishedAt": "2024-08-04T12:27:00Z",
//       "content": null
//     },
//     {
//       "source": {
//         "id": "google-news",
//         "name": "Google News"
//       },
//       "author": "CNN",
//       "title": "Trump attacked this GOP Governor. Why reporter calls it ‘unexpected’ - CNN",
//       "description": "GDP stands for Gross Domestic Product. It represents the market value of all the final goods and services produced within the geographical boundaries of a country within a specific time frame, typically a year or a quarter. GDP is a critical indicator of the economic health of a country. GDP at constant prices, also known as real GDP, is a measure of GDP that adjusts for changes in the overall price level ",
//       "url": "https://news.google.com/rss/articles/CBMiqwFBVV95cUxQUTYyMGxvbDdfUmxaaWlicnJjWWFGRENtaXc5ZWU0b0F1VlBEY3FtZUIzX0NtaDZGM0c1T0g5V2kzQmNqUGlmRENPdE0xS0M5enpVTlNaZkxRRHpIb1lyeHlTck5UVGg4RWxMMWNwWWlqRFhMb3lCM1J2NDNIQ2RoMGx3VGdGbDZpTDRJWUJhbHk5Mk5TSWhueFdiRTItUzJuTkZTZHpLMlVlOTg?oc=5",
//       "urlToImage": "https://th.bing.com/th/id/OIP.OAWHRCxfg2SXcWu51l9OcgHaEK?w=312&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7",
//       "publishedAt": "2024-08-04T11:39:07Z",
//       "content": null
//     },
//     {
//       "source": {
//         "id": "google-news",
//         "name": "Google News"
//       },
//       "author": null,
//       "title": "6 Words Explain Why Warren Buffett Just Dumped Half of His $160 Billion Stake in Apple - Inc.",
//       "description": "GDP stands for Gross Domestic Product. It represents the market value of all the final goods and services produced within the geographical boundaries of a country within a specific time frame, typically a year or a quarter. GDP is a critical indicator of the economic health of a country. GDP at constant prices, also known as real GDP, is a measure of GDP that adjusts for changes in the overall price level ",
//       "url": "https://consent.google.com/m",
//       "urlToImage": "https://th.bing.com/th/id/OIP.vkXzx-YGRXdU_utrETFkVwHaE5?w=251&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7",
//       "publishedAt": "2024-08-04T11:31:20Z",
//       "content": "We use cookies and data to\r\n\u003Cul\u003E\u003Cli\u003EDeliver and maintain Google services\u003C/li\u003E\u003Cli\u003ETrack outages and protect against spam, fraud, and abuse\u003C/li\u003E\u003Cli\u003EMeasure audience engagement and site statistics to un… [+1139 chars]"
//     },
//     {
//       "source": {
//         "id": "usa-today",
//         "name": "USA Today"
//       },
//       "author": "Ehsan Kassim",
//       "title": "Olympic golf leaderboard: Live scores, results from Round 4 at Le Golf National in Paris - USA TODAY",
//       "description": "Here's what the leaderboard looks like in golf competition at the 2024 Paris Olympics for Round 4 on Sunday at Le Golf National:",
//       "url": "https://www.usatoday.com/story/sports/olympics/2024/08/04/olympic-golf-leaderboard-scores-results-round-4-le-golf-national-2024-paris-olympics-how-to-watch/74660754007/",
//       "urlToImage": "https://www.usatoday.com/gcdn/authoring/authoring-images/2024/08/03/PNAS/74657442007-usatsi-23900524.jpg?crop=3077,1731,x0,y64&width=3077&height=1731&format=pjpg&auto=webp",
//       "publishedAt": "2024-08-04T11:26:15Z",
//       "content": "The final round of golf at the 2024 Paris Olympics from Le Golf National should bring an interesting finish.\r\nDefending gold medalist and United States star golfer Xander Schauffele enters the fourth… [+6529 chars]"
//     },
//     {
//       "source": {
//         "id": "politico",
//         "name": "Politico"
//       },
//       "author": null,
//       "title": "He’s the rare Trump adviser to survive the first term. He’s poised to be even more influential in a second. - POLITICO",
//       "description": "The man in charge of burning down the global trading system knows how to make friends in Washington.",
//       "url": "https://www.politico.com/news/2024/08/04/robert-lighthizer-trump-adviser-trade-00172530",
//       "urlToImage": "https://static.politico.com/40/9e/2d9a2e334808a71b134dd9850e5e/congress-trade-65662.jpg",
//       "publishedAt": "2024-08-04T11:00:00Z",
//       "content": "At the time of the meeting, many lawmakers of both parties were still skeptical of the rewritten NAFTA and the radical turn against decades of free trade orthodoxy that Trump and his trade chief had … [+10306 chars]"
//     },
//     {
//       "source": {
//         "id": "google-news",
//         "name": "Google News"
//       },
//       "author": "NPR",
//       "title": "Thailand still grapples with a strict law against criticizing the monarchy - NPR",
//       "description": "GDP stands for Gross Domestic Product. It represents the market value of all the final goods and services produced within the geographical boundaries of a country within a specific time frame, typically a year or a quarter. GDP is a critical indicator of the economic health of a country. GDP at constant prices, also known as real GDP, is a measure of GDP that adjusts for changes in the overall price level ",
//       "url": "https://news.google.com/rss/articles/CBMiowFBVV95cUxQTXFYXzY5a0NXQ3lCUEpocjBLWkNXdktlT3QwSDBtMm9rNDE1MXZpTUhUSUVkN1ZMdnc4N2d3Ymp4Ny1yOVFmSWduRmpSUFdEeE5IcGJWbmRNZWhfNG4wX3hFWHdfODRGTzYxdVExbGQ2R192QUE0Nmtxd0lOLS04dXcxTjJ6cWsxUTFJZV9qc01lVzd1aWJSc0tQaFdPcUdCaWtJ?oc=5",
//       "urlToImage": "https://npr.brightspotcdn.com/dims3/default/strip/false/crop/5000x3335+0+0/resize/900/quality/85/format/webp/?url=http%3A%2F%2Fnpr-brightspot.s3.amazonaws.com%2F7d%2Ff5%2F79ddfd9a45ef8c2036664f809ffd%2Fgettyimages-1529659266.jpg",
//       "publishedAt": "2024-08-04T11:00:00Z",
//       "content": null
//     },
//     {
//       "source": {
//         "id": "reuters",
//         "name": "Reuters"
//       },
//       "author": "Reuters",
//       "title": "Two Russian ex-prisoners from East-West swap want to return home - Reuters",
//       "description": "The swap saw eight Russians, including a convicted murderer, returned home from Western countries in exchange for 16 prisoners freed from Russian and Belarusian jails.",
//       "url": "https://www.reuters.com/world/europe/two-russian-ex-prisoners-east-west-swap-want-return-home-2024-08-04/",
//       "urlToImage": "https://www.reuters.com/resizer/v2/W7VJUC3Q25OV5IMM33GXODOKK4.jpg?auth=6d8e99366ab1deb5a95ea0694d20504530fc0a3ddc985613279ba759224c11cc&height=1005&width=1920&quality=80&smart=true",
//       "publishedAt": "2024-08-04T10:50:00Z",
//       "content": null
//     },
//     {
//       "source": {
//         "id": "google-news",
//         "name": "Google News"
//       },
//       "author": "Seeking Alpha",
//       "title": "Stocks Poised To Fall Further Amid Massive Bond And Currency Market Shifts - Seeking Alpha",
//       "description":"GDP stands for Gross Domestic Product. It represents the market value of all the final goods and services produced within the geographical boundaries of a country within a specific time frame, typically a year or a quarter. GDP is a critical indicator of the economic health of a country. GDP at constant prices, also known as real GDP, is a measure of GDP that adjusts for changes in the overall price level ",
//       "url": "https://news.google.com/rss/articles/CBMikgFBVV95cUxQYWw1YzFCUGZhaHpXU3BNRmhpTTFLU0dKeUN1NGpLWEtsdHJXY01OOFR1N1lKMXNxZGtpdlpLWGRhVjA4blZzTUpJeXVfbnVxSVRqOUhDd2VyREFoWHEtN0pYN05HTU5wUFVWTU5lYkhNcWlRR3hRT2EteEx6TEZSUnliaW95YTdmQ3FGOWc1RTZLQQ?oc=5",
//       "urlToImage": "https://th.bing.com/th/id/OIP.NBFeydSPsYBZfWyAssSGqAHaEE?w=307&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7",
//       "publishedAt": "2024-08-04T10:15:00Z",
//       "content": null
//     },
//     {
//       "source": {
//         "id": "google-news",
//         "name": "Google News"
//       },
//       "author": "ABC News",
//       "title": "Ukraine intensifies its long-range strikes, sinking a Russian submarine and striking an airfield - ABC News",
//       "description": "GDP stands for Gross Domestic Product. It represents the market value of all the final goods and services produced within the geographical boundaries of a country within a specific time frame, typically a year or a quarter. GDP is a critical indicator of the economic health of a country. GDP at constant prices, also known as real GDP, is a measure of GDP that adjusts for changes in the overall price level ",
//       "url": "https://news.google.com/rss/articles/CBMivgFBVV95cUxQMXI4cVdWaW1WbWd4RVloMlJJdlFnbkl6NHpmME5qZ0RBN2N4eHJSeXNpbUdSLXdZRzgxQW9xOXFnTlJtOVBmWFl3S3gwV21MQTdpU2FnVHFUSjVSQk9NdFFJX3dkdHl1eVRpdmhQOW9TYzdJUzVDeXNBMGxib1o3djVSYjVWb2tHd3ZBOEsyOHQtd0pFS3I0UE0tLW4xOG9kN1lwdWtrR0hKSkd1MXRmUFdwRlZNLU1ER1lDMzBB0gHDAUFVX3lxTE1JdzVJR0JQOG5aSnY5ZGx1V1E3RHRLNWw3UFJLaXlCX0VLMG1tWVVBdnI3TDAtVF8yOXAtenV1cS1pTFdjMWU3cHpDS0ZIZGVWSS16T3NQOXZKNjd3MGg0MncyUHFIb0s3NWpqMEV0ZzN3d0VPeXdNLUtfdXVOeWxGRUxyR1kxcUc5NENWUUFoN0VoV1YxTjFPc1FmTmFsMUUtVlpPRm1iNkNsRkRpNHNlYlMxdWtrd3c2MzRMQ3VDQW5TNA?oc=5",
//       "urlToImage": "https://th.bing.com/th/id/OIP.l4so8caimdSI1bOT35bYMAAAAA?w=228&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7",
//       "publishedAt": "2024-08-04T10:07:42Z",
//       "content": null
//     },
//     {
//       "source": {
//         "id": "google-news",
//         "name": "Google News"
//       },
//       "author": "NPR",
//       "title": "Is a high-profile critic of the Chinese Communist Party a con man? - NPR",
//       "description": "GDP stands for Gross Domestic Product. It represents the market value of all the final goods and services produced within the geographical boundaries of a country within a specific time frame, typically a year or a quarter. GDP is a critical indicator of the economic health of a country. GDP at constant prices, also known as real GDP, is a measure of GDP that adjusts for changes in the overall price level ",
//       "url": "https://news.google.com/rss/articles/CBMihgFBVV95cUxNSGYwSEJJUkZRRUFwZ2lHempyR2o3SXdyMHZOc3BMc1RNRkpjdHRLVXhXM1dsdS1YY1d4TlR3MU5FcDBRMzhSbUx6SFhoNVd3YWFGeDJhNDF0ajBBVkFXazhCQmlmc2NpQlhIdHAxc3NZR21PM2dnbGtSUWhnVzR6UUE3QUlmZw?oc=5",
//       "urlToImage": "https://th.bing.com/th/id/OIP.e8piT3nuVkvYzQXzgl19JAHaEK?w=294&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7",
//       "publishedAt": "2024-08-04T10:00:00Z",
//       "content": null
//     },
//     {
//       "source": {
//         "id": "google-news",
//         "name": "Google News"
//       },
//       "author": "Forbes",
//       "title": "See Perseid Meteors Peak With The Northern Lights: The Night Sky This Week - Forbes",
//       "description": "GDP stands for Gross Domestic Product. It represents the market value of all the final goods and services produced within the geographical boundaries of a country within a specific time frame, typically a year or a quarter. GDP is a critical indicator of the economic health of a country. GDP at constant prices, also known as real GDP, is a measure of GDP that adjusts for changes in the overall price level ",
//       "url": "https://news.google.com/rss/articles/CBMiygFBVV95cUxQQjM4OG5GaDVCeDRiandXVGJFNm5rVVBRclBzY09jMUVtVEVUUUg2cU5NdVRfbzVVVVhyUzRxeUo5NmxPNktFU1o4T1V4SGFVVUY4V0FIUFpyeGR1YmlCbVFPX1g1OXE3bWhObEo4Z09BY0Y2MGdQd1JDU01zQVZ5MG84RnRUekVZSUFSc0xKQTI5OVYtRllwRWRRS0lVT3A3NVA5RUlERWNMVVJGajJPQ1lWdWZnZ0tuNzdaUUY1bWhndWNIdHRQZXln?oc=5",
//       "urlToImage": "https://www.gannett-cdn.com/presto/2020/08/07/PRRS/0666ed9c-77a0-402d-8aa5-b981754dadb1-LakeHelenallmeteorsstack.jpg?crop=2999,1687,x0,y277&width=2999&height=1687&format=pjpg&auto=webp",
//       "publishedAt": "2024-08-04T10:00:00Z",
//       "content": null
//     },
//     {
//       "source": {
//         "id": null,
//         "name": "BBC News"
//       },
//       "author": null,
//       "title": "Trump and Harris at odds over presidential debate - BBC.com",
//       "description": "The two candidates trade barbs as broadcasters negotiate details of new debates ahead of the November election.",
//       "url": "https://www.bbc.com/news/articles/cv2g22365yqo",
//       "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/33b3/live/1e8d4be0-51bd-11ef-b2d2-cdb23d5d7c5b.jpg",
//       "publishedAt": "2024-08-04T09:17:50Z",
//       "content": "Jenny KumahReporting from\r\nWashington, DC\r\nTom Bennett\r\nUS presidential candidates Donald Trump and Kamala Harris are at odds over their first head-to-head debate, with each in favour of a different … [+3048 chars]"
//     },
//   ]

//    CapitalizeFirstLetter=(string) => {
//     return (string.charAt(0)).toUpperCase() + this.props.category.slice(1);   //this function hold string and also convert 1st letter to uppercase of any string
//    }

//     constructor(props){
//     super(props);
//     console.log("hellow i am a constructor from news component")
//     this.state={      //this.state is use to change any veriable and specific data dynamically without reloading a whole page
//     articles: [],
//     loading:false,
//     page:1,
//     }
//     document.title=`${this.CapitalizeFirstLetter(this.props.category)} - NewsMonkey`;
//   }
  

//    async componentDidMount(){
//     this.props.setProgress(10);
//     const proxyUrl = "https://corsproxy.io/?";
//     const apiKey = process.env.REACT_APP_NEWS_API_KEY;
//     let url = `https://newsapi.org/v2/top-headlines?country=${this.props.country}&category=${this.props.category}&apiKey=${apiKey}&page=1&pageSize=${this.props.pageSize}`;   //here pagesize difine using props means we change a pagesize only one place then this apply all the page where we difine props.
//     this.setState({loading:true});   //whenever api fetch untill loading icon show 
//     let data = await fetch(proxyUrl + encodeURIComponent(url));
//     let parsedData = await data.json()
//     console.log(parsedData);
//     this.setState({articles: parsedData.articles,
//       totalResults: parsedData.totalResults,
//     loading:false //when api fetch and data comes on page then loading false
//   })
//   this.props.setProgress(100);
//   }

  

//       fetchMoreData = async ()=>{
//     const proxyUrl = "https://corsproxy.io/?";
//     let url = `https://newsapi.org/v2/top-headlines?country=${this.props.country}&category=${this.props.category}&apiKey=${process.env.REACT_APP_NEWS_API_KEY}&page=${this.state.page+1}&pageSize=${this.props.pageSize}`;
//     this.setState({page:this.state.page+1});
//     this.setState({loading:true}); //whenever previous page api fetch untill loading icon show 
//     let data = await fetch(proxyUrl + encodeURIComponent(url));
//     let parsedData = await data.json()

//     this.setState({
//       articles: this.state.articles.concat(parsedData.articles),
//       totalResults: parsedData.totalResults,
//       loading:false,
//       })
//     };

//   render() {
//     return (
//       <>
//         <h2 className='text-center text-danger' style={{marginTop:'90px'}}>News Monkey - Top {this.CapitalizeFirstLetter(this.props.category)} Headlines</h2>
//         {/*this.state.loading && <Spinner/>*/}
//         <InfiniteScroll
//           dataLength={this?.state?.articles?.length}
//           next={this.fetchMoreData}
//           hasMore={this.state.articles?.length !== this.state.totalResults}
//           loader={<Spinner/>}
//         >
//           <div className='container'>
//         <div className='row'>
//         {this.state.articles.map((element)=>{   //here when page is a not loading state then display any content otherwise not display content
//   return     <div className='col-md-4' key={element.url}>
//             <NewsItem title={element.title?element.title.slice(0, 45):""} description={element.description?element.description.slice(0, 85):""}
//              imageUrl={element.urlToImage} 
//              newsUrl={element.url}
//              author={element.author}
//              date={element.publishedAt}
//              source={element.source.name}/>
//             </div>
//         })}
//         </div>
//         </div>
//         </InfiniteScroll>
//       </>
//     )
//   }
// }




import React, { Component } from 'react'
import NewsItem from './NewsItem'
import Spinner from './Spinner';
import PropTypes from 'prop-types'
import InfiniteScroll from "react-infinite-scroll-component";

export default class News extends Component {
    static defaultProps = {
        country: 'in',
        pageSize: 8,
        category: 'general'
    }

    static propTypes = {
        country: PropTypes.string,
        pageSize: PropTypes.number,
        category: PropTypes.string
    }

    capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    constructor(props) {
        super(props);
        this.state = {
            articles: [],
            loading: true,
            page: 1,
            totalResults: 0
        }
        document.title = `${this.capitalizeFirstLetter(this.props.category)} - NewsMonkey`;
    }

    // Helper to build the internal API URL
    // buildUrl = (page) => {
    //     return `/api/news?country=${this.props.country}&category=${this.props.category}&page=${page}&pageSize=${this.props.pageSize}`;
    // }

    buildUrl = (page) => {
    const apiKey = process.env.REACT_APP_NEWS_API_KEY;
    
    // Check if we are running on our local computer
    const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

    if (isLocal) {
        // LOCAL: Call NewsAPI directly (it allows localhost)
        return `https://newsapi.org/v2/top-headlines?country=${this.props.country}&category=${this.props.category}&page=${page}&pageSize=${this.props.pageSize}&apiKey=${apiKey}`;
    } else {
        // PRODUCTION (Vercel): Call your serverless function
        return `/api/news?country=${this.props.country}&category=${this.props.category}&page=${page}&pageSize=${this.props.pageSize}`;
    }
}

    async updateNews() {
        this.props.setProgress(10);
        const url = this.buildUrl(this.state.page);
        this.setState({ loading: true });
        
        let data = await fetch(url);
        let parsedData = await data.json();
        
        this.props.setProgress(70);
        this.setState({
            articles: parsedData.articles || [],
            totalResults: parsedData.totalResults || 0,
            loading: false
        });
        this.props.setProgress(100);
    }

    async componentDidMount() {
        this.updateNews();
    }

    fetchMoreData = async () => {
        const nextPage = this.state.page + 1;
        const url = this.buildUrl(nextPage);
        
        let data = await fetch(url);
        let parsedData = await data.json();

        this.setState({
            articles: this.state.articles.concat(parsedData.articles || []),
            totalResults: parsedData.totalResults || 0,
            page: nextPage
        });
    };

    render() {
        return (
            <>
                <header className="news-page-header">
                    <h2>
                        Top {this.capitalizeFirstLetter(this.props.category)} Headlines
                    </h2>
                    <p>Stay informed with the latest stories from NewsMonkey</p>
                </header>
                {this.state.loading && <Spinner />}
                
                <InfiniteScroll
                    dataLength={this.state.articles.length}
                    next={this.fetchMoreData}
                    hasMore={this.state.articles.length !== this.state.totalResults}
                    loader={<Spinner />}
                >
                    <div className='container news-container'>
                        <div className='row news-grid'>
                            {this.state.articles.map((element) => {
                                return (
                                    <div className='col-md-6 col-lg-4' key={element.url}>
                                        <NewsItem 
                                            title={element.title ? element.title.slice(0, 45) : ""} 
                                            description={element.description ? element.description.slice(0, 85) : ""}
                                            imageUrl={element.urlToImage} 
                                            newsUrl={element.url}
                                            author={element.author}
                                            date={element.publishedAt}
                                            source={element.source.name} 
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </InfiniteScroll>
            </>
        )
    }
}